mc.cache.setItem("rc2_deviceId", mc.utils.id(), true);

let getDefaultState = function (defaults = {}) {
  let deviceId = mc.cache.getItem("rc2_deviceId");
  let user = mc.cache.getItem("rc2_user");
  let prefs = mc.cache.getItem("rc2_prefs") || {};

  let state = {
    deviceId: deviceId,
    accountId: user ? user.user.accountId : null,
    user: user && user.expiration > Date.now() ? user : null,
    users: [],
    prefs: prefs,
    studies: [],
    study: {}, // by studyId
    studyStats: {}, // by studyId
    subjects: {}, // by subjectId
    annotations: {}, // by subjectId
    equipment: {}, // by subjectId
    equipmentLog: {}, // by serialNumber
    metrics: {}, // by subjectId
    channels: [], // TODO by subjectId, startTs
    unreadMessages: [], // unread messages from any subject in any studies
    messages: {}, // by subjectId
    subjectComplianceStats: {}, // by subjectId
    studyComplianceStats: {}, // by subjectId (merged across studies)
    recordingStats: {}, // by subjectId (merged across studies)
    faultStats: {} // by subjectId (merged across studies)
  };

  return { ...state, ...defaults };
};

let reducers = {
  login: function (state, action) {
    let user = action.user;
    let accountId = user ? user.user.accountId : null;

    mc.cache.setItem("rc2_user", user);

    return getDefaultState({ user, accountId });
  },

  logout: function (state, action) {
    let user = null;
    let accountId = null;

    mc.cache.setItem("rc2_user", user);

    return getDefaultState({ user, accountId });
  },

  setPref: function (state, action) {
    let prefs = { ...state.prefs, [action.name]: action.value };

    mc.cache.setItem("rc2_prefs", prefs);

    return { ...state, prefs };
  },

  setPrefs: function (state, action) {
    let prefs = { ...state.prefs, ...action.prefs };

    mc.cache.setItem("rc2_prefs", prefs);

    return { ...state, prefs };
  },

  loadUsers: function (state, action) {
    return { ...state, users: action.users };
  },

  saveUser: function (state, action) {
    if (action.errors.length === 0) {
      // if self
      if (state.user && state.user.user.id === action.user.id) {
        let user = { ...state.user, user: action.user };

        mc.cache.setItem("rc2_user", user);

        return { ...state, user };
      }
    }

    return { ...state };
  },

  loadStudies: function (state, action) {
    return { ...state, studies: action.studies };
  },

  loadStudyStats: function (state, action) {
    return { ...state, studyStats: action.stats };
  },

  loadStudy: function (state, action) {
    let study = { ...state.study, [action.study.id]: action.study };

    return { ...state, study };
  },

  loadSubject: function (state, action) {
    let subjects = { ...state.subjects, [action.subject.id]: action.subject };

    return { ...state, subjects };
  },

  saveStudy: function (state, action) {
    if (action.errors.length === 0) {
      return reducers.loadStudy(state, action);
    }

    return { ...state };
  },

  saveSubject: function (state, action) {
    if (action.errors.length === 0) {
      return reducers.loadSubject(state, action);
    }

    return { ...state };
  },

  loadAnnotations: function (state, action) {
    let annotations = { ...state.annotations, [action.subjectId]: action.annotations };

    return { ...state, annotations };
  },

  saveAnnotation: function (state, action) {
    // TODO modify state.annotations
    return { ...state };
  },

  loadEquipment: function (state, action) {
    let equipment = { ...state.equipment, [action.subjectId]: action.equipment };

    return { ...state, equipment };
  },

  loadEquipmentLog: function (state, action) {
    let equipmentLog = { ...state.equipmentLog, [action.serialNumber]: action.equipmentLog };

    return { ...state, equipmentLog };
  },

  saveProgram: function (state, action) {
    if (action.errors.length === 0) {
      let studyId = action.program.parentEntityId;

      if (state.study[studyId]) {
        state.study[studyId].program = action.program;
      }
    }

    return { ...state };
  },

  loadMetrics: function (state, action) {
    let metrics = { ...state.metrics, [action.subjectId]: action.metrics };
    return { ...state, metrics };
  },

  loadChannels: function (state, action) {
    return { ...state, channels: action.channels };
  },

  loadUnreadMessages: function (state, action) {
    return { ...state, unreadMessages: action.messages };
  },

  loadMessages: function (state, action) {
    let messages = { ...state.messages, [action.subjectId]: action.messages };

    return { ...state, messages };
  },

  readMessages: function (state, action) {
    // modify in place
    let messages = state.messages[action.subjectId] || [];

    messages.forEach(function (message) {
      message.isRead = message.isRead || action.messageIds.includes(message.id);
    });

    return { ...state };
  },

  loadSubjectComplianceStats: function (state, action) {
    let subjectComplianceStats = { ...state.subjectComplianceStats, [action.subjectId]: action.stats };

    return { ...state, subjectComplianceStats };
  },

  loadStudyComplianceStats: function (state, action) {
    let studyComplianceStats = { ...state.studyComplianceStats, ...action.stats };

    return { ...state, studyComplianceStats };
  },

  loadRecordingStats: function (state, action) {
    let recordingStats = { ...state.recordingStats, ...action.stats };

    return { ...state, recordingStats };
  },

  loadFaultStats: function (state, action) {
    let faultStats = { ...state.faultStats, ...action.stats };

    return { ...state, faultStats };
  }
};

let store = mc.state.createStore(reducers, getDefaultState());

module.exports = store;
